import { DatePipe } from '@angular/common';
import { ChangeDetectorRef, Component, EventEmitter, Input, OnChanges, OnInit, Output, SimpleChanges, ViewChild } from '@angular/core';
import { BookingService } from 'app/modules/bookings/services/booking.service';
import { AppSettings } from '../../app.settings';
import { CommonBindingDataService } from '../../services/common-binding-data.service';
import { UiService } from '../../services/ui.service';
import { UserCommonService } from '../../services/user-common.service';
import { MiGrid2Component } from '../mi-grid-2/mi-grid-2.component';
import * as momentImported from 'moment';
const moment = (momentImported as any).default || momentImported;
import { ConfirmationService } from 'primeng/api';

export interface AssignBookingDisplayInfo {
  subServiceTypeStatusLabel: string;
  pickupDateTime: number;
  tripId: string;
  tourStatusString: string;
  pFirstName: string;
  pLastName: string;
  pNumCountryCode: string;
  pPhoneNum: string;
  passengerType: string;
  privilage: string;
  eligibility: string;
  passengerNote: string;
  totalNoOfPassengers: number;
  totalNoOfWheelchairs: number;
  totalNoOfBabyseats: number;
  totalNoOfChildseats: number;
  totalNoOfLuggageBags: number;
  tripTitle: string;
  pickupLocationName: string;
  dropLocationName: string;
  pickupAddressNote: string;
  tripNote: string;
  tenantServiceAreaId: string;
  driverId: string;
  id: string;
  passengerId: string;
  subServiceType?: number;
  tourStatus?: number;
  tourLocationsList?: any[];
  dedicatedTourLocationDtoList?: any[];
}

@Component({
  selector: 'app-assign-driver-v2',
  templateUrl: './assign-driver-v2.component.html',
  styleUrls: ['./assign-driver-v2.component.scss'],
  providers: [DatePipe]
})
export class AssignDriverV2Component implements OnInit, OnChanges {

  @ViewChild(MiGrid2Component) gridRef2: MiGrid2Component;
  @Input() bookingId: any = '';
  @Input() dedicatedTourDaywiseDataId: any = null;
  @Input() dedicatedTourId: any = null;
  @Input() dedicatedPickupDateTime: any = null;
  @Input() dedicatedEndDateTime: any = null;
  @Input() visible: boolean = false;
  @Output() visibleChange: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() sideBarHide: EventEmitter<any> = new EventEmitter();

  selectedTab: boolean = false;
  listMapOptions = [
    { icon: 'pi pi-map', label: ' Map', value: 'map' },
    { icon: 'pi pi-list', label: ' List', value: 'list' }
  ];
  value: any = 'list';

  filterApplied = false;
  searchPlaceHolder = 'Search by driver name, call sign';
  originalFilterData: any;
  selectedWatchList: any = '';
  changedFilterData: any;
  filterButtonClass = 'filter-btn-apply';
  gridScrollHeight = '';

  columns: any = [];
  params: any = '';
  url = '/secure/tour/list/data?type=ACTIVE&subServiceType=';

  assignBookingInfo: AssignBookingDisplayInfo | null = null;
  tourBookingInfo: any = null;
  passengerInfo: any;
  currentStatus = AppSettings.CURRENT_DRIVER_STATUS;
  selectedCurrentStatus: any = '';
  radiusOption = AppSettings.RADIUS_LIST;
  selectedRadius: any;
  parkingLocationsOptions: any[] = [];
  defaultOrAssignedParking = '';
  selectedparkingLocation: any;
  bookingDetail: any;
  defaultSelectedparkingLocation: any = '';
  sortTypeOptions = AppSettings.DRIVER_ASSIGN_SORT;
  selectedSortType: any;
  teamsOptions: any[] = [];
  selectedTeam: any = '';
  dispatchZonesOption: any[] = [];
  selectedDispatchZones: any = '';
  availableForServiceOptions: any[] = [];
  readonly defaultAvailableForService: any = 'BOTH';
  selectedAvailableForService: any = this.defaultAvailableForService;

  checked: boolean = false;
  viewDaysBooking: boolean = false;
  isDisplayUpcommingList = false;
  upcomingBookingTitle = '';
  driverId: any;
  showThirdPartyList: Boolean = false;
  thirdPartyList = [];
  thirdPartEventChecked;
  toThirdParty = false;
  pagination: boolean = false;
  datePipeString: string;
  fromDate: any = null;
  toDate: any = null;
  bookingType: any = '';
  tempUrl = ''
  passengersTodaysActiveBookings = 0;
  recordCount = 0;
  estimatedDropoffTime: any;
  showScanQrOption = false;
  bookingStatus;
  eventIdParam = '';
  readonly defaultParkingLocation = 'all_drivers';
  readonly defaultSortType = 'idle_time';
  readonly defaultRadius = '10';
  readonly defaultTeam = '';
  readonly defaultCurrentStatus = '';
  readonly dateTimeFormatStr: string = 'MM/DD/YYYY HH:mm';

  constructor(
    private commonBindingDataService: CommonBindingDataService,
    private userCommonService: UserCommonService,
    private uiService: UiService,
    private bookingService: BookingService,
    private datePipe: DatePipe,
    private confirmationService: ConfirmationService,
    private cdr: ChangeDetectorRef,
  ) { }

  ngOnInit(): void {
    this.commonBindingDataService.eventId.subscribe(result => {
      this.eventIdParam = result;
      this.loadData();
    });

    if (!this.eventIdParam) {
      let tempEventId = this.commonBindingDataService.changedEventId;
      if (tempEventId) {
        this.eventIdParam = tempEventId;
        this.loadData();
      }
    }
  }

  ngOnChanges(changes: SimpleChanges): void {
  }

  loadData() {
    console.log('loadData');
    if (!this.bookingId) {
      return;
    }
    this.selectedTab = false;
    this.getDispatchZones();
    this.getAvailableForServiceOptions();
    this.columns = [];
    this.defineColumns();
    this.getBookingDetails();
  }

  getDispatchZones() {
    this.commonBindingDataService.getCitiesV1(this.eventIdParam).subscribe(results => {
      this.dispatchZonesOption = results.map(ele => ({ label: ele.cityAliasName, value: ele.id }));
    });
  }

  getAvailableForServiceOptions() {
    this.availableForServiceOptions = JSON.parse(JSON.stringify(AppSettings.AVAILABLE_FOR_SERVICE_OPTIONS));
    this.availableForServiceOptions.unshift({ label: this.commonBindingDataService.getLabel('label_all'), value: 'BOTH' });
  }

  defineColumns() {
    this.columns = [];
    this.columns.push({
      field: 'driverName', width: 150, header: this.commonBindingDataService.getLabel('label_driver'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getDriverInfo(i)),
    });
    this.columns.push({
      field: 'teamName', width: 100, header: this.commonBindingDataService.getLabel('label_team'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getTeamInfo(i)),
    });
    this.columns.push({
      field: 'pFirstName', width: 130, header: this.commonBindingDataService.getLabel('label_vehicle_info'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getVehicleInfo(i)),
    });
    this.columns.push({
      field: 'pFirstName2', width: 130, header: this.commonBindingDataService.getLabel('label_availability'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getavailabilityInfo(i)),
    });
    this.columns.push({
      field: 'pFirstName3', width: 130, header: this.commonBindingDataService.getLabel('label_eta_to_pickup'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.getEtaToPickupInfo(i)),
    });

    if (this.tourBookingInfo?.subServiceTypeStatus !== AppSettings.SUB_BOOKINMG_SERVICE_TYPES.OUTBOUND) {
      this.columns.push({
        field: 'pFirstName4', width: 130, header: this.commonBindingDataService.getLabel('label_checkin_status'),
        sort: false, resize: true, cellRendererHtml: (i) => (this.getCheckinStatusInfo(i)),
      });
      this.columns.push({
        field: 'pFirstName5', width: 130, header: this.commonBindingDataService.getLabel('label_current_driver_status'),
        sort: false, resize: true, cellRendererHtml: (i) => (this.getDriverCurrentStatusInfo(i)),
      });
    }

    this.columns.push({
      field: '', header: this.commonBindingDataService.getLabel('label_action'),
      sort: false, resize: true, cellRendererHtml: (i) => (this.actionCells(i)), width: '100px'
    });
  }

  getCheckinStatusInfo(params) {
    const eDiv = document.createElement('div');
    let checkinStatusInfo = `
      <div>
      <span class='checkin-status clamp-two-line'>
       <span class='default'>NA</span>
       </span>
       </div>`;

    if (params.parkingLocationName) {
      checkinStatusInfo = `
        <div title="Checked in at ${params.parkingLocationName} since ${params.parkingSinceTimeStr}">
        <span class='checkin-status clamp-two-line'>
         Checked in at
         <span class='default'>${params.parkingLocationName}</span>
         since
         <span class='default'>${params.parkingSinceTimeStr}</span>
         </span>
         </div>`;
    }

    eDiv.innerHTML += checkinStatusInfo;
    return eDiv;
  }

  getTeamInfo(params) {
    const eDiv = document.createElement('div');
    let driverName = `
    <div>
    <span class='driver-name'>${params.shiftName ? params.shiftName : 'NA'}</span>
     </div>
     <div>
     ${params.shiftName ?
        `<span class='driver-teams'>${params.currentShiftSlotStartDateTime ? this.datePipe.transform(params.currentShiftSlotStartDateTime, 'H:mm') : ''}</span>
    <span class='driver-teams'>${params.currentShiftSlotStartDateTime && params.currentShiftSlotEndDateTime ? ' - ' : 'No Slots'}</span>
    <span class='driver-teams'>${params.currentShiftSlotEndDateTime ? this.datePipe.transform(params.currentShiftSlotEndDateTime, 'H:mm') : ''}
    </div>`: ''}`;

    eDiv.innerHTML += driverName;
    return eDiv;
  }

  getDriverInfo(params) {
    const eDiv = document.createElement('div');
    const isUpcoming = params.upcomingCount ? `<span data-action-type='UpcomingBooking' class='upcoming-booking'>Active: ${params.upcomingCount}</span>` :
      `<span class='no-upcoming'>No Active<span>`;
    const isCompleted = params.completedBookingCount ? `<span data-action-type='CompletedBooking' class='upcoming-booking'>Completed: ${params.completedBookingCount}</span>` :
      `<span class='no-upcoming'>No Completed<span>`;
      
    let driverName = `
    <div>
    <span class='driver-name'>${params.driverName}</span>
     </div>
     <div>
    ${isCompleted} <span class='divider'></span> ${isUpcoming}
    </div>`;
    eDiv.innerHTML += driverName;
    return eDiv;
  }

  getVehicleInfo(params) {
    const eDiv = document.createElement('div');
    let vehicleName = `
    <div>
    ${params.wheelchairSupport ? `<i class="fa fa-wheelchair wheelchar" aria-hidden="true"></i>` : ''}
    <span class='vehicle-reg'>NA</span>
    </div>`;
    if (params.vehicleCode !== null) {
      vehicleName = `
      <div>
      ${params.wheelchairSupport ? `<i class="fa fa-wheelchair wheelchar" aria-hidden="true"></i>` : ''}
      <span class='vehicle-reg'>${params.vehicleCode ? params.vehicleCode : ''}</span>
       <span class='vehicle-type'>(${params?.vehicleType ? params?.vehicleType : ''}${params?.capacity ? ' - ' + params?.capacity : ''})</span>
       </div>
       <div>
      <span class='vehicle-model'>${params?.makeModel ? params?.makeModel : ''}${params?.modelName ? ' - ' + params?.modelName : ''}</span>
      </div>`;
    }

    eDiv.innerHTML += vehicleName;
    return eDiv;
  }

  getavailabilityInfo(params) {
    let availabilityTaskinfo = '';
    if (params.taskName) {
      availabilityTaskinfo = `
    <div>
      <span class='availablity'>
        <span class="driver-task-name" title="${params.taskDescription}">${params.taskName ? `(<span class="driver-on-task">On Task : </span>${params.taskName})` : ''}</span>
      </span>
    </div>`;
    }

    let availabilityinfo = `
    <div>
      <span class='availablity'>
        <span class='default'>${params.driverCurrentStatus}</span>
      </span>
    </div>`;
    const eDiv = document.createElement('div');
    const pickupDropLocation = `
    <div style="margin-top: -13px;margin-bottom: -4px; width: 500px">
    <div class="col-12 booking-grid-table booking-details pad-top" title="">
    <div class="col-12 grid mt-1">
      <div class="col-1 md:col-1 lg:col-2 passenger-name address-container">
        <div class="start-point-new"><img src="/assets/images/temp/pickup.png"></div>
        <div class="divider" style='height:23px'></div>
        <div class="end-point-new"><img src="/assets/images/temp/drop-off.png"></div>
      </div>
      <div class="col-10 md:col-10 lg:col-10">
      <div class="pickup-location"> Pickup Location</div>
      <div class="pickup-location-name" title="${params.upcomingTripPickupLocationName}">` + params.upcomingTripPickupLocationName + `</div>
      <div class="pickup-location"> Drop Off Location Location</div>
      <div class="pickup-location-name" title="${params.upcomingTripDropLocationName}">` + params.upcomingTripDropLocationName + `</div>
      </div>
    </div>
    </div></div>`;

    const popup = params.upcomingTripId ? `
    <div class='tooltip'>
    <span>
    <div class='grid'>
    <div class='tooltip-pickup-date col'>${this.datePipeString = this.datePipe.transform(params.upcomingTripPickupDateTime, 'H:mm, d MMM y')} </div>
    <div class='close col-fixed'><li class='fa fa-times'></div>
   </div>
    ${pickupDropLocation}
     </span></div>`: '';

    const pickupDropLocationNext = `
     <div style="margin-top: -13px;margin-bottom: -4px; width: 500px">
     <div class="col-12 booking-grid-table booking-details pad-top" title="">
     <div class="col-12 grid mt-1">
       <div class="col-1 md:col-1 lg:col-2 passenger-name address-container">
         <div class="start-point-new"><img src="/assets/images/temp/pickup.png"></div>
         <div class="divider" style='height:23px'></div>
         <div class="end-point-new"><img src="/assets/images/temp/drop-off.png"></div>
       </div>
       <div class="col-10 md:col-10 lg:col-10">
       <div class="pickup-location"> Pickup Location</div>
       <div class="pickup-location-name" title="${params.nextUpcomingTripPickupLocationName}">` + params.nextUpcomingTripPickupLocationName + `</div>
       <div class="pickup-location"> Drop Off Location Location</div>
       <div class="pickup-location-name" title="${params.nextUpcomingTripDropoffLocationName}">` + params.nextUpcomingTripDropoffLocationName + `</div>
       </div>
     </div>
     </div></div>`;

    const popupNext = params.nextUpcomingTripTripId ? `
     <div class='tooltip'>
     <span>
     <div class='grid'>
     <div class='tooltip-pickup-date col'>${this.datePipeString = this.datePipe.transform(params.nextUpcomingTripPickupDateTime, 'H:mm, d MMM y')} </div>
     <div class='close col-fixed'><li class='fa fa-times'></div>
    </div>
     ${pickupDropLocationNext}
      </span></div>`: '';

    if (params.dutyStatus == false) {
      availabilityinfo = `
        <div>
          <span class='availablity'>
            <span class='driver-off-duty'>Off Duty</span>
          </span>
        </div>`;
    } else if (params.driverCurrentStatus == "Busy") {
      availabilityinfo = `
      <div>
        <span class='availablity'>
          <span class='${params.driverCurrentStatus ? params.driverCurrentStatus.toLowerCase() : 'default'}'>${params.driverCurrentStatus + ' - ' + (params.currentTripTourStatusStr ? params.currentTripTourStatusStr : 'NA')}</span>
        </span>
      </div>
    `;
    } else if (params.driverCurrentStatus == "Available") {
      availabilityinfo = `
      <div>
        <span class='availablity'>
          <span class='${params.driverCurrentStatus ? params.driverCurrentStatus.toLowerCase() : 'default'}'>${params.driverCurrentStatus}</span>
          <span class="driver-task-name" title="${params.taskDescription}">${params.taskName ? `(<span class="driver-on-task">On Task : </span>${params.taskName})` : ''}</span>
        </span>
      </div>`;
    } else {
      availabilityinfo = `
      <div>
        <span class='availablity'>
          <span class='${params.driverCurrentStatus ? params.driverCurrentStatus.toLowerCase() : 'NA'}'>${params.driverCurrentStatus || 'NA'}</span>
        </span>
      </div>`;
    }

    let upcomingInfo = `
    <div>
      <span class='availablity'>Previous Upcoming :
        ${params.upcomingTripId
        ? `<span class='show-location'><span class='booking-number'>${params.upcomingTripId}</span>${popup}</span>`
        : `<span class='default'>NA</span>`}
      </span>
    </div>`;

    let nextUpcomingInfo = '';
    if (params.nextUpcomingTripTripId) {
      nextUpcomingInfo = `
      <div>
        <span class='availablity'>Next Upcoming:
          ${params.nextUpcomingTripTripId
          ? `<span class='show-location'><span class='booking-number'>${params.nextUpcomingTripTripId}</span>${popupNext}</span>`
          : `<span class='default'>NA</span>`}
        </span>
      </div>`;
    }

    eDiv.innerHTML += availabilityinfo + upcomingInfo + nextUpcomingInfo + availabilityTaskinfo;
    eDiv.setAttribute('class', 'row-color');
    return eDiv;
  }

  getEtaToPickupInfo(params) {
    const eDiv = document.createElement('div');
    let onOffShiftStatus = '';
    let nextEtaInfo = '';
    let etaInfo = `
                  <div class="mt-2">
                  <span class='eta-to-pickup'>NA</span>
                  </div>`;
    if (params.etaToPickupTimeStr !== null && params.etaToPickupDistanceStr !== null) {
      etaInfo = `
             <div class="mt-2">
             <span class='eta-to-pickup' style="font-size: 17px;font-weight: bold;">${params.estimatedArrivalDateTimeAtPickup ? this.datePipe.transform(params.estimatedArrivalDateTimeAtPickup, 'HH:mm ') : 'NA'}
             <span class='miles'>(${params.etaToPickupDistanceStr ? params.etaToPickupDistanceStr : 'NA'})</span>
            </span>
            </div>`;
    }
    if (params.estArrivalDateTimeAtNextUpcomingPickup !== null && params.estDistToReachAtNextUpcomingPickupStr !== null) {
      nextEtaInfo = `
             <div class="mt-2">
             <span class='eta-to-pickup' style="font-size: 14px;">${params.estArrivalDateTimeAtNextUpcomingPickup ? this.datePipe.transform(params.estArrivalDateTimeAtNextUpcomingPickup, 'HH:mm ') : ''}
             <span class='miles'>(${params.estDistToReachAtNextUpcomingPickupStr ? params.estDistToReachAtNextUpcomingPickupStr : ''})</span>
            </span>
            </div>`;
    }

    if (params.bookingWillCompleteInSameShiftSlot == "yes") {
      onOffShiftStatus = `<div><span class='colorGreen'>On shift for pickup</span></div>`;
    } else {
      onOffShiftStatus = `<div><span class='colorRed'>Off shift for pickup</span></div>`;
    }

    eDiv.innerHTML += onOffShiftStatus + etaInfo + nextEtaInfo;
    return eDiv;
  }

  getDriverCurrentStatusInfo(params) {
    const eDiv = document.createElement('div');
    const date = new Date();

    let driverCurrentStatusInfo = `
      <div>
      <span class='current-driver-status clamp-two-line'>
       <span class='default'>NA</span>
       </span>
       </div>`;

    const pickupDropLocation = `
    <div style="margin-top: -13px;margin-bottom: -4px; width: 500px">
    <div class="col-12 booking-grid-table booking-details pad-top" title="">
    <div class="col-12 grid mt-1">
      <div class="col-1 md:col-1 lg:col-2 passenger-name address-container">
        <div class="start-point-new"><img src="/assets/images/temp/pickup.png"></div>
        <div class="divider" style='height:23px'></div>
        <div class="end-point-new"><img src="/assets/images/temp/drop-off.png"></div>
      </div>
      <div class="col-10 md:col-10 lg:col-10">
      <div class="pickup-location"> Pickup Location </div>
      <div class="pickup-location-name" title="${params.currentTripPickupLocationName}">` + params.currentTripPickupLocationName + `</div>
      <div class="pickup-location"> Drop Off Location </div>
      <div class="pickup-location-name" title="${params.currentTripDropLocationName}">` + params.currentTripDropLocationName + `</div>
      </div>
    </div>
    </div></div>`;

    const popup = params.currentTripId ? `
    <div class='tooltip'>
    <span>
    <div class='grid'>
    <div class='tooltip-pickup-date col'>${this.datePipeString = this.datePipe.transform(params.currentTourPickupDateTime, 'H:mm, d MMM y')} </div>
    <div class='close col-fixed'><li class='fa fa-times'></div>
   </div>
    ${pickupDropLocation}
     </span></div>`: '';

    if (params.currentTripId) {
      driverCurrentStatusInfo = `
      <div>

      <span class='current-driver-status clamp-two-line'>
      <span class='show-location'><span class='booking-number'>${params.currentTripId}</span>${popup}</span>
       <span title="${params.currentTripId} Drop off at ${params.currentTripDropLocationName} estimated drop off time ${(params.currentTripTourStatus == AppSettings.BOOKING_STATUS_CODES.ON_TRIP || date.getTime() > params.currentTourPickupDateTime)
          ? this.datePipe.transform(date.getTime() + params?.currentTripEtaToDropTime, 'H:mm')
          : this.datePipe.transform(params?.currentTourPickupDateTime + params?.currentTripEtaToDropTime, 'H:mm')}">Drop off at
       <span class='default'>${params.currentTripDropLocationName}</span>
       estimated drop off time
       <span class='default'>${(params.currentTripTourStatus == AppSettings.BOOKING_STATUS_CODES.ON_TRIP || date.getTime() > params.currentTourPickupDateTime)
          ? this.datePipe.transform(date.getTime() + params?.currentTripEtaToDropTime, 'H:mm')
          : this.datePipe.transform(params?.currentTourPickupDateTime + params?.currentTripEtaToDropTime, 'H:mm')}</span>
          </span>
       </span>
       </div>`;
    }


    eDiv.innerHTML += driverCurrentStatusInfo;
    return eDiv;
  }

  getTeamList() {
    this.commonBindingDataService.getShiftGroupList(this.eventIdParam, this.selectedDispatchZones).subscribe(result => {
      this.teamsOptions = result.map(ele => ({ label: `${ele.name.length > 15 ? `${ele.name.slice(0, 15)}...` : ele.name}`, value: ele.id }));
      this.teamsOptions.unshift({ label: this.commonBindingDataService.getLabel('label_all_teams'), value: '' });
    });
  }

  getParkingLocations() {
    if (this.userCommonService.userMetaData) {
      const defaultParkingOptions = [
        { label: 'All Driver', value: 'all_drivers' },
        { label: 'All Checked - In', value: 'all_checked_in' },
        { label: 'All Non Checked - In', value: 'all_non_checked_in' }
      ];
      this.userCommonService.userMetaData.locationCategorisList.forEach(element => {
        if (element.id === AppSettings.LOCATION_TYPES.PARKING) {
          this.commonBindingDataService.getParkingLocationsList(element.id, this.selectedDispatchZones, this.eventIdParam).subscribe(
            (result) => {
              this.parkingLocationsOptions = result.data.map(eachLocation => (
                { label: eachLocation.displayAddress, value: eachLocation.id }
              ));
              this.parkingLocationsOptions = [...defaultParkingOptions, ...this.parkingLocationsOptions];
              this.selectedparkingLocation =
                (this.parkingLocationsOptions.length > 0) ? (this.defaultOrAssignedParking ?
                  this.defaultOrAssignedParking : this.parkingLocationsOptions[0].value) : this.defaultSelectedparkingLocation;
              this.defaultSelectedparkingLocation = this.selectedparkingLocation ? this.selectedparkingLocation : '';
            }, (error) => {
            });
        }
      });
    }
  }

  getBookingDetails() {
    console.log('getBookingDetails', this.dedicatedTourDaywiseDataId);
    if (this.dedicatedTourDaywiseDataId) {
      this.getDedicatedBookingDetails();
      return;
    }
    this.getCurrentBookingDetails();
  }

  private getCurrentBookingDetails() {
    this.bookingService.fetchTourBooking(this.bookingId, this.eventIdParam, null, null).subscribe(results => {
      const date = new Date();
      this.bookingDetail = results;
      this.passengerInfo = results.passengerInfo;
      this.applyNormalizedBooking(this.mapFromCurrentBooking(results.tourBookingInfo, results.passengerInfo));
      this.passengersTodaysActiveBookings = (results.totalJourneys && results.totalJourneys > 0) ? results.totalJourneys : 0;

      if (results.estimatesInfo?.time) {
        if (date.getTime() > this.tourBookingInfo.pickupDateTime) {
          this.estimatedDropoffTime = this.datePipe.transform(date.getTime() + results.estimatesInfo.time, 'H:mm');
        } else {
          this.estimatedDropoffTime = this.datePipe.transform(this.tourBookingInfo.pickupDateTime + results.estimatesInfo.time, 'H:mm');
        }
      } else {
        this.estimatedDropoffTime = 'NA';
      }

      this.bookingStatus = results.tourBookingInfo.tourStatus;
      this.setScanQrOption(results.tourBookingInfo);
      this.initializeBookingSuccessState();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    });
  }

  getDedicatedBookingDetails() {
    const date = this.dedicatedPickupDateTime
      ? moment(this.dedicatedPickupDateTime).startOf('day').valueOf()
      : moment().startOf('day').valueOf();
    this.bookingService.getDedicatedTimeline(this.bookingId, date, this.dedicatedTourDaywiseDataId).subscribe(
        (res: any) => {
          const timeline = Array.isArray(res)
            ? (res.find(ele => ele.id === this.dedicatedTourDaywiseDataId) || res[0])
            : res;
          this.bookingDetail = { timelineData: timeline };
          this.applyNormalizedBooking(this.mapFromDedicatedTimeline(timeline));
          this.passengersTodaysActiveBookings = timeline.totalJourneys || 0;
          this.estimatedDropoffTime = timeline.endDateTimeStr
            ? this.datePipe.transform(timeline.endDateTime, 'H:mm')
            : 'NA';
          this.bookingStatus = timeline.daywiseTourStatus;
          this.showScanQrOption = false;
          this.initializeBookingSuccessState();
        },
        (error) => {
          this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
        }
      );
  }

  private setScanQrOption(tourBookingInfo: any) {
    if (
      this.bookingStatus <= AppSettings.BOOKING_STATUS_CODES.ADMIN_CONFIRMED &&
      (tourBookingInfo.subServiceType !== AppSettings.JOURNEY_TYPE_VALUES.VEHICLE_TRANSFER) &&
      (tourBookingInfo.subServiceType !== AppSettings.JOURNEY_TYPE_VALUES.THIRD_PARTY)
    ) {
      this.showScanQrOption = true;
    } else {
      this.showScanQrOption = false;
    }
  }

  private initializeBookingSuccessState() {
    this.selectedDispatchZones = this.tourBookingInfo.tenantServiceAreaId;
    this.tempUrl = `/secure/drivers/assign-trip-v3/${this.bookingId}/list/data`;
    this.getTeamList();
    this.getParkingLocations();
    this.defineColumns();
    this.initializeUrl();
    this.cdr.detectChanges();
  }

  private applyNormalizedBooking(info: AssignBookingDisplayInfo) {
    this.assignBookingInfo = info;
    this.tourBookingInfo = { ...info };
    this.passengerInfo = {
      id: info.passengerId,
      passengerType: info.passengerType,
      privilage: info.privilage,
      eligibility: info.eligibility,
      passengerNote: info.passengerNote,
    };
  }

  private mapFromCurrentBooking(tourBookingInfo: any, passengerInfo: any): AssignBookingDisplayInfo {
    return {
      subServiceTypeStatusLabel: tourBookingInfo?.subServiceTypeStatusLabel || '',
      pickupDateTime: tourBookingInfo?.pickupDateTime || 0,
      tripId: tourBookingInfo?.tripId || '',
      tourStatusString: tourBookingInfo?.tourStatusString || '',
      pFirstName: tourBookingInfo?.pFirstName || '',
      pLastName: tourBookingInfo?.pLastName || '',
      pNumCountryCode: tourBookingInfo?.pNumCountryCode || '',
      pPhoneNum: tourBookingInfo?.pPhoneNum || '',
      passengerType: passengerInfo?.passengerType || '',
      privilage: passengerInfo?.privilage || '',
      eligibility: passengerInfo?.eligibility || '',
      passengerNote: passengerInfo?.passengerNote || '',
      totalNoOfPassengers: tourBookingInfo?.totalNoOfPassengers || 0,
      totalNoOfWheelchairs: tourBookingInfo?.totalNoOfWheelchairs || 0,
      totalNoOfBabyseats: tourBookingInfo?.totalNoOfBabyseats || 0,
      totalNoOfChildseats: tourBookingInfo?.totalNoOfChildseats || 0,
      totalNoOfLuggageBags: tourBookingInfo?.totalNoOfLuggageBags || 0,
      tripTitle: tourBookingInfo?.tripTitle || '',
      pickupLocationName: tourBookingInfo?.pickupLocationName || '',
      dropLocationName: tourBookingInfo?.dropLocationName || '',
      pickupAddressNote: tourBookingInfo?.pickupAddressNote || '',
      tripNote: tourBookingInfo?.tripNote || '',
      tenantServiceAreaId: tourBookingInfo?.tenantServiceAreaId || '',
      driverId: tourBookingInfo?.driverId || '',
      id: tourBookingInfo?.id || '',
      passengerId: passengerInfo?.id || tourBookingInfo?.passengerId || '',
      subServiceType: tourBookingInfo?.subServiceType,
      tourStatus: tourBookingInfo?.tourStatus,
      tourLocationsList: tourBookingInfo?.tourLocationsList,
      dedicatedTourLocationDtoList: tourBookingInfo?.dedicatedTourLocationDtoList,
    };
  }

  private mapFromDedicatedTimeline(timeline: any): AssignBookingDisplayInfo {
    return {
      subServiceTypeStatusLabel: 'Dedicated Booking',
      pickupDateTime: timeline?.pickupDateTime || 0,
      tripId: timeline?.daywiseDisplayTourId || '',
      tourStatusString: timeline?.daywiseTourStatusStr || this.getDedicatedDaywiseStatusLabel(timeline?.daywiseTourStatus),
      pFirstName: timeline?.passengerFirstName || '',
      pLastName: timeline?.passengerLastName || '',
      pNumCountryCode: timeline?.passengerNumCountryCode || '',
      pPhoneNum: timeline?.passengerPhoneNum || '',
      passengerType: timeline?.passengerType || '',
      privilage: timeline?.privilege || '',
      eligibility: timeline?.eligibility || '',
      passengerNote: timeline?.passengerNote || '',
      totalNoOfPassengers: timeline?.totalNoOfPassengers || 0,
      totalNoOfWheelchairs: timeline?.totalNoOfWheelchairs || 0,
      totalNoOfBabyseats: timeline?.totalNoOfBabyseats || 0,
      totalNoOfChildseats: timeline?.totalNoOfChildseats || 0,
      totalNoOfLuggageBags: timeline?.totalNoOfLuggageBags ?? timeline?.totalNoOfBaggage ?? 0,
      tripTitle: '',
      pickupLocationName: timeline?.pickupLocationDisplayName || timeline?.pickupLocationCode || 'NA',
      dropLocationName: 'NA',
      pickupAddressNote: timeline?.pickupLocationDisplayAddress || timeline?.pickupLocationAddress || 'NA',
      tripNote: timeline?.daywiseBookingNote || 'NA',
      tenantServiceAreaId: timeline?.tenantServiceAreaId || '',
      driverId: timeline?.driverId || '',
      id: timeline?.id || this.dedicatedTourDaywiseDataId || '',
      passengerId: timeline?.passengerId || '',
      subServiceType: undefined,
      tourStatus: timeline?.daywiseTourStatus,
      tourLocationsList: undefined,
      dedicatedTourLocationDtoList: timeline?.dedicatedTourLocationDtoList,
    };
  }

  private getDedicatedDaywiseStatusLabel(statusCode: number): string {
    const option = AppSettings.DEDICATED_DAYWISE_TOUR_STATUS_OPTIONS.find(ele => ele.value === statusCode);
    return option?.label || 'NA';
  }

  actionCells(params) {
    let isDriverAssignLabel = this.commonBindingDataService.getLabel('label_assign');
    const eDiv = document.createElement('div');
    eDiv.setAttribute('class', 'grid-btn-div buttons');
    const btn = `<div data-action-type='assignDriver' class="grid-btn-div assign-driver-btn pb-2">
       ${isDriverAssignLabel} </div>`;
    eDiv.innerHTML = btn;
    return eDiv;
  }

  showPassengerDayBookings() {
    this.viewDaysBooking = true;
  }

  closeUpcomingCompletedPopup() {
    this.isDisplayUpcommingList = false;
  }

  backNavigate(param?) {
    this.visible = false;
    this.visibleChange.emit(false);
    this.sideBarHide.emit();
  }

  onRowClicked(e: any) {
    const actionType = e.originalEvent.target.getAttribute('data-action-type');
    switch (actionType) {
      case 'assignDriver':
        return this.assignDriver(e.data);
      case 'UpcomingBooking':
        this.bookingType = 'UPCOMINGACTIVE';
        this.upcomingBookingTitle = 'Active Bookings';
        this.isDisplayUpcommingList = true;
        this.driverId = e.data.driverId;
        break;
      case 'CompletedBooking':
        this.upcomingBookingTitle = 'Completed Bookings';
        this.bookingType = 'COMPLETED';
        this.isDisplayUpcommingList = true;
        this.driverId = e.data.driverId;
        break;
      default:
        break;
    }
  }

  onSwitchChange(event) {
    this.showThirdPartyList = true;
    this.thirdPartEventChecked = event.checked;
  }

  selectCurrentVendor(event) {
    const data = {
      assignThirdParty: this.thirdPartEventChecked,
      transportVendorId: event.id
    }
    this.commonBindingDataService.AssigneToAndFromThirdParty(this.tourBookingInfo.id, data).subscribe(results => {
      this.showThirdPartyList = false;
      this.uiService.showMessage(results.general[0].message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.backNavigate();
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    });
  }

  popUpCancel(event: any) {
    this.showThirdPartyList = false;
    this.toThirdParty = !this.toThirdParty;
  }

  getActivatedThirdPartList() {
    this.commonBindingDataService.getVendorCompaniesList().subscribe(results => {
      this.thirdPartyList = Array.isArray(results) ? results : (results?.getTransportVendorsList || []);
    }, (error) => {

      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    });
  }

  assignDriver(driverDetails) {
    if(this.dedicatedTourDaywiseDataId){
      this.assignDedicatedDriver(driverDetails);
      return;
    }
    let message = '';
    const isTrue = (driverDetails.canDriverCompleteInputTripInTimeBeforeNextPickup == false || driverDetails.canDriverCompleteInputTripInTimeBeforeNextPickupWithBuffer == false) ? true : false;
    if (driverDetails.dutyStatus == false) {
      this.confirmationService.confirm({
        message: this.commonBindingDataService.getLabel('label_off_duty_confirm'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.assignDriverApi(driverDetails);
        }
      });
    } else if (driverDetails.bookingWillCompleteInSameShiftSlot != "yes") {
      this.confirmationService.confirm({
        message: this.commonBindingDataService.getLabel('label_booking_complete_in_shift_slot'),
        icon: 'pi pi-info-circle',
        accept: () => {
          this.assignDriverApi(driverDetails);
        }
      });
    } else if ((driverDetails.showAlert && (driverDetails?.confirmationMessage != '' || null || undefined)) || isTrue) {
      if ((driverDetails.showAlert && (driverDetails?.confirmationMessage != '' || null || undefined)) && isTrue) {
        message = `The selected driver will not arrive on time for pickup, and it is estimated that if you assign this trip to the selected driver, the driver will not arrive on time for pickup of the next trip <strong>${driverDetails.nextUpcomingTripTripId}</strong>. Do you want to continue?`;
      } else if ((driverDetails.showAlert && (driverDetails?.confirmationMessage != '' || null || undefined))) {
        message = driverDetails?.confirmationMessage;
      } else {
        message = `If you assign this booking the driver may be late for pickup of their existing booking <strong>${driverDetails.nextUpcomingTripTripId}</strong>. Do you wish to continue?`
      }

      this.confirmationService.confirm({
        message: message,
        icon: 'pi pi-info-circle',
        accept: () => {
          this.assignDriverApi(driverDetails);
        }
      });
    } else {
      this.confirmationService.confirm({
        message: `Driver expected to fulfil booking. Pickup Time ${this.datePipe.transform(this.tourBookingInfo.pickupDateTime, 'HH:mm')}; Driver ETA (no buffer) ${driverDetails.estimatedArrivalDateTimeAtPickup ? this.datePipe.transform(driverDetails.estimatedArrivalDateTimeAtPickup, 'HH:mm ') : 'NA'}. Do you wish to continue?`,
        icon: 'pi pi-info-circle',
        accept: () => {
          this.assignDriverApi(driverDetails);
        }
      });
    }
  }

  assignDriverApi(driverDetails) {
    const newDriverId = driverDetails.driverId;
    const isAssigned = (this.tourBookingInfo.driverId) ? true : false;
    const payload: any = {
      tourIdOrTripId: this.tourBookingInfo.id,
      driverIdOrCode: newDriverId,
      reassigned: isAssigned,
      overridden: false
    };

    if (this.dedicatedTourDaywiseDataId) {
      payload.dedicatedTourDaywiseDataId = this.dedicatedTourDaywiseDataId;
    }

    this.commonBindingDataService.driverAssigned(payload).subscribe(results => {
      const message = (results && results.general && results.general[0] && results.general[0].message)
        ? results.general[0].message
        : (results && results.message) ? results.message : '';
      this.uiService.showMessage(message, AppSettings.MESSAGE_TYPE.SUCCESS);
      this.backNavigate();
    }, (error) => {
      const message = (error && error.general && error.general[0] && error.general[0].message)
        ? error.general[0].message
        : (error && error.message) ? error.message : '';
      this.uiService.showMessage(message, AppSettings.MESSAGE_TYPE.ERROR);
    });
  }

  assignDedicatedDriver(driverDetails, isDriverBusy?) {
    const data = {
      driverId: driverDetails.driverId,
      vehicleId: driverDetails.vehicleId,
      checkDriverBusy: isDriverBusy ? false : true,
    };
    const requestedStartDatetimeStr = moment(this.dedicatedPickupDateTime).format(this.dateTimeFormatStr);
    const requestedEndDatetimeStr = moment(this.dedicatedEndDateTime).format(this.dateTimeFormatStr);
    this.bookingService.assignDriverAndVehicleToDedicated(this.dedicatedTourDaywiseDataId, data, 'ASSIGN', requestedStartDatetimeStr, requestedEndDatetimeStr).subscribe(result => {
      if(!result.isDriverBusy){
        this.uiService.showMessage(result.message, AppSettings.MESSAGE_TYPE.SUCCESS);
        this.backNavigate();
      } else {
        this.confirmationService.confirm({
          message: result.message,
          icon: 'pi pi-info-circle',
          accept: () => {
            this.assignDedicatedDriver(driverDetails, result.isDriverBusy);
          },
          reject: () => {
          }
        });
      }
    }, (error) => {
      this.uiService.showMessage(error.general[0].message, AppSettings.MESSAGE_TYPE.ERROR);
    });
  }

  initializeUrl() {
    this.resetFilter();
  }

  resetFilter() {
    this.defaultSelectedparkingLocation = this.defaultParkingLocation;
    this.selectedCurrentStatus = this.defaultCurrentStatus;
    this.selectedSortType = this.defaultSortType;
    this.selectedRadius = this.defaultRadius;
    this.selectedTeam = this.defaultTeam;
    this.selectedDispatchZones = this.tourBookingInfo.tenantServiceAreaId;
    this.selectedAvailableForService = this.defaultAvailableForService;
    this.params = this.tempUrl.includes('?') ? '&' : '?';
    this.fromDate = moment(this.tourBookingInfo?.pickupDateTime).startOf('day').valueOf();
    this.toDate = moment(this.tourBookingInfo?.pickupDateTime).endOf('day').valueOf();
    this.params += (`parkingLocationId=${this.defaultSelectedparkingLocation}`);
    this.params += (`&driverCurrentStatus=${this.selectedCurrentStatus}`);
    this.params += (`&listSortKey=${this.selectedSortType}`);
    this.params += (`&radiusToPickup=${this.selectedRadius}`);
    this.params += (`&serviceAreaId=${this.selectedDispatchZones}`);
    this.params += (`&availableForService=${this.selectedAvailableForService}`);
    this.params += (`&shiftId=${this.selectedTeam}`);
    this.params += (`&fromDate=${this.fromDate}`);
    this.params += (`&toDate=${this.toDate}`);

    if(this.dedicatedTourDaywiseDataId){
      this.params += (`&dedicatedTourId=${this.dedicatedTourId}`);
      this.params += (`&dedicatedTourDaywiseDataId=${this.dedicatedTourDaywiseDataId}`);
    }
    this.gridRef2.updateUrl(this.tempUrl + this.params)
    this.updateSaveFilter();
  }

  gateAndSetAllFilters() {
    // Filter persistence for this flow is intentionally disabled in this branch.
  }

  gateAllFilters() {
    return null;
  }

  makeAllFilterToString() {
    // Filter persistence for this flow is intentionally disabled in this branch.
  }

  updateSaveFilter() {
    this.filterApplied = false;
  }

  totalCount(event: any) {
    this.recordCount = event;
  }

  changeFilter(key?, val?) {
    if (!this.changedFilterData) {
      this.changedFilterData = {};
    }
    this.changedFilterData[key] = val !== undefined && val !== null ? val.toString() : '';
    this.filterApplied = true;
  }

  applyFilter() {
    this.params = this.tempUrl.includes('?') ? '&' : '?';
    this.fromDate = moment(this.tourBookingInfo?.pickupDateTime).startOf('day').valueOf();
    this.toDate = moment(this.tourBookingInfo?.pickupDateTime).endOf('day').valueOf();

    this.params += (`parkingLocationId=${this.defaultSelectedparkingLocation}`);
    this.params += (`&driverCurrentStatus=${this.selectedCurrentStatus}`);
    this.params += (`&listSortKey=${this.selectedSortType}`);
    this.params += (`&radiusToPickup=${this.selectedRadius}`);
    this.params += (`&serviceAreaId=${this.selectedDispatchZones}`);
    this.params += (`&availableForService=${this.selectedAvailableForService}`);
    this.params += (`&shiftId=${this.selectedTeam}`);
    this.params += (`&fromDate=${this.fromDate}`);
    this.params += (`&toDate=${this.toDate}`);

    if(this.dedicatedTourDaywiseDataId){
      this.params += (`&dedicatedTourId=${this.dedicatedTourId}`);
      this.params += (`&dedicatedTourDaywiseDataId=${this.dedicatedTourDaywiseDataId}`);
    }

    this.gridRef2.updateUrl(this.tempUrl + this.params);
    this.updateSaveFilter();
  }

  toCurrentTimeZone(now) {
    const date = new Date(now);
    return new Date(date.getTime() + (date.getTimezoneOffset() * 60000)).getTime();
  }

  loadList(e) {
    if (e?.value) {
      this.value = e.value;
    }
    if (this.value === 'list') {
      this.applyFilter();
    }
  }

  getStopAddress(bookingInfo: AssignBookingDisplayInfo | any) {
    if (!bookingInfo) {
      return 'NA';
    }
    let stopAddress = '';
    if (bookingInfo.tourLocationsList) {
      if (bookingInfo.tourLocationsList.length > 2) {
        for (let i = 0; i < bookingInfo.tourLocationsList.length; i++) {
          if (bookingInfo.tourLocationsList[i].locationType == 'STOP') {
            stopAddress = (bookingInfo.tourLocationsList[i].address ? bookingInfo.tourLocationsList[i].address : 'NA');
            break;
          }
        }
      } else {
        stopAddress = 'NA';
      }
    }
    if(this.dedicatedTourDaywiseDataId && bookingInfo?.dedicatedTourLocationDtoList?.length){
      stopAddress = `${bookingInfo.dedicatedTourLocationDtoList.length} ${bookingInfo.dedicatedTourLocationDtoList.length > 1 ? 'Stops' : 'Stop'}`;
    }
    return stopAddress || 'NA';
  }

}
